import { render, staticRenderFns } from "./index.vue?vue&type=template&id=655d96dd"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655d96dd')) {
      api.createRecord('655d96dd', component.options)
    } else {
      api.reload('655d96dd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=655d96dd", function () {
      api.rerender('655d96dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-page/no-permission/index.vue"
export default component.exports